import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CURRENT_CLIENT_TEMPLATE_VAR, utils } from '@core';
import { IncidentModel, IncidentNoteModel } from '@models';
import { firstValueFrom as toPromise, map, Observable } from 'rxjs';

/**
 * @deprecated
 */
@Injectable({ providedIn: 'root' })
export class IncidentsService {
  private http = inject(HttpClient);

  getAllIncidents(): Observable<IncidentModel[]> {
    return this.http
      .get<{ data: IncidentModel[]; }>(`incidents/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/incidents/open`, {
        params: {
          deviceStatus: ['active', 'paused'],
        },
      })
      .pipe(map(data => data.data));
  }

  getAllResolvedIncidents(params: Record<string, string> = {}): Observable<IncidentModel[]> {
    return this.http
      .get<{ data: IncidentModel[]; }>(`incidents/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/incidents/resolved`, { params })
      .pipe(map(data => data.data));
  }

  getIncidentById(incidentId: string): Observable<IncidentModel> {
    return this.http
      .get<{ data: IncidentModel; }>(`incidents/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/incidents/${incidentId}?includeDeviceInfo=true`)
      .pipe(map(data => data.data));
  }

  getIncidentNotes(incidentId: string) {
    return this.http
      .get<{ data: IncidentNoteModel[]; }>(`incidents/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/incidents/${incidentId}/notes`)
      .pipe(map(data => data.data));
  }

  async getIncidentsStats<T>(filters = {}) {
    const { data } = await toPromise(
      this.http.get<{ data: T; }>(`incidents/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/incidents/statistics`, {
        params: utils.clearObject(filters),
      }),
    );

    return data;
  }

  addIncidentNote(incidentId: string, body: { textValue: string; }) {
    return this.http
      .post<{ data: IncidentNoteModel; }>(`incidents/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/incidents/${incidentId}/notes`, {
        ...body,
        source: 'api',
      })
      .pipe(map(data => data.data));
  }
}
